export default __webpack_public_path__ + "static/media/gmail.a2f2146f.png";